import { Context } from '@nuxt/types';
import './utils/vconsole.ts';
export default async function (context: Context) {}
